<template>
    <div class="connection">
        <preloader :display="loading" class="preloader" />
        <div v-if="!loading">
            <p class="typographies-paragraph-medium-bold title">Connexion</p>

            <form
                id="staffConnection"
                name="staffConnection"
                action="#"
                method="POST"
                target="_blank"
            >
                <div v-if="showConsentFeatures">
                    <!-- Needed these hidden inputs for connexion: SellsyAdmin/initConnectionForm -->
                    <input type="hidden" name="mode" value="saas" />
                    <input type="hidden" name="hash" :value="connectionSelectModel" />
                    <CompassSelect
                        v-if="hasActiveConsents || hasPendingConsents"
                        v-model="connectionSelectModel"
                        :placeholder="
                            hasPendingConsents ? $l10n.__('Aucune autorisation active') : ''
                        "
                        filterable
                        class="connection__select"
                    >
                        <CompassOptionGroup
                            v-if="hasPendingConsents"
                            :label="$t.__('common.labels.access_awaiting_authorization')"
                        >
                            <CompassDropdownSelectOption
                                v-for="option in filteredStaff.pending"
                                :key="option.value"
                                :value="option.value"
                                :label="option.label"
                                :avatar="option.avatar"
                                :labelCaption="option.labelCaption"
                                type="avatar"
                                :disabled="true"
                            />
                        </CompassOptionGroup>
                        <CompassOptionGroup
                            v-if="hasActiveConsents"
                            :label="$t.__('sellsyadmin.Connection.authorized_access')"
                        >
                            <CompassDropdownSelectOption
                                v-for="option in filteredStaff.active"
                                :key="option.value"
                                :value="option.value"
                                :label="option.label"
                                :avatar="option.avatar"
                                :labelCaption="option.labelCaption"
                                :caption="option.caption"
                                type="avatar"
                            />
                        </CompassOptionGroup>
                    </CompassSelect>
                    <!-- Empty connexion -->
                    <div v-else class="connection__empty">
                        <p class="typographies-paragraph-medium-regular">
                            {{ $l10n.__('Aucun accès disponible') }}
                        </p>
                    </div>
                </div>
                <!-- Old select version -->
                <div v-else>
                    <input type="hidden" name="mode" value="saas" />
                    <div class="form-group form-group-block" style="margin-bottom: 5px">
                        <div class="form-input" style="display: block">
                            <select name="hash" style="width: 100%">
                                <option
                                    v-for="(staff, staffIndex) in staffsData"
                                    v-if="
                                        staff.status != 'deleted' && staff.corpid == corporationid
                                    "
                                    :key="staffIndex"
                                    :value="staff.hash"
                                    :selected="staff.staffid === selectedStaff.staffid"
                                >
                                    {{ fullname(staff) }} - [STAFFID {{ staff.staffid }}]
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="connection__actions">
                        <CompassButton
                            :label="$t.__('sellsyadmin.Connection.saas')"
                            type="secondary"
                            @click="connection('saas')"
                        />
                        <CompassButton
                            :label="$t.__('sellsyadmin.Connection.mobile')"
                            type="secondary"
                            @click="connection('mobilev2')"
                        />
                    </div>
                </div>
                <!-- Old select version -->
                <div v-if="showConsentFeatures && hasActiveConsents" class="connection__actions">
                    <CompassButton
                        :label="$t.__('sellsyadmin.Connection.saas')"
                        type="secondary"
                        @click="connection('saas')"
                    />
                    <CompassButton
                        :label="$t.__('sellsyadmin.Connection.mobile')"
                        type="secondary"
                        @click="connection('mobilev2')"
                    />
                </div>
            </form>
        </div>
        <template v-if="showConsentFeatures && showConsentRequest">
            <span class="divider" />
            <CompassButton
                :label="$t.__('sellsyadmin.Connection.access_request')"
                :disabled="!showConsentRequest"
                @click="handleConsentDemandDialog"
            />
            <!-- <ConnectionConsentDialog
                v-if="displayConsentDialog"
                :visible="displayConsentDialog"
                :demand-type="getDemandType"
                :staff="activeStaff"
                :third-id="parseInt(thirdid)"
                :corp-id="parseInt(corporationid)"
                @close="handleCloseDialog"
                @success="handleSuccessDialog"
            /> -->
        </template>
    </div>
</template>
<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import ConnectionConsentDialog from './ConnectionConsentDialog.vue';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;
const { mapState, mapGetters } = createNamespacedHelpers('user');

import AvatarMixins from 'mixins/AvatarMixins';

export default {
    components: {
        Preloader,
        ConnectionConsentDialog,
    },
    mixins: [AvatarMixins],
    props: {
        thirdid: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            corporationid: 0,
            typeUser: '',
            staffsData: [],
            selected: '',
            displayConsentDialog: false,
            connectionSelectModel: '',
            filteredStaff: {},
            permissions: {},
            impersonateConsentCheck: false,
            level: '',
        };
    },
    computed: {
        ...mapGetters(['getUser']),
        ...mapState({
            isAdmin: 'isAdmin',
        }),
        activeStaff() {
            return this.staffsData.filter((item) => !['blocked', 'deleted'].includes(item.status));
        },
        hasActiveConsents() {
            return this.filteredStaff.active?.length > 0;
        },
        hasPendingConsents() {
            return this.filteredStaff.pending?.length > 0;
        },
        selectedStaff() {
            const staffSellsy = this.staffsData.find(
                (staffData) => staffData.staffType === 'sellsy',
            );
            if (staffSellsy) {
                return staffSellsy;
            } else {
                return this.staffsData.find((staffData) => staffData.ownerid === 0);
            }
        },
        canConnect() {
            if (this.getUserAuthorizationLevel === 'trial' && this.level !== 'trial') {
                return false;
            }

            return this.$store.state.third
                ? this.$store.getters.permissions.sellsyadmin_can_connect
                : this.permissions.sellsyadmin_can_connect;
        },
        showConsentFeatures() {
            return this.impersonateConsentCheck;
        },
        ...mapGetters(['getPermissions']),
        getDemandType() {
            return this.getPermissions.masquerade.authorization;
        },
        getUserAuthorizationLevel() {
            return this.getPermissions.masquerade.level;
        },
        showConsentRequest() {
            return this.getUserAuthorizationLevel === 'gold' && this.level === 'gold';
        },
    },

    async created() {
        this.typeUser = this.getUser.permissions.masquerade.authorization;

        if (!this.$store.state.third) {
            await this.getThirdPermissions();
        }

        /* Get, filter and sort data */
        await this.fetch();
        this.filteredStaffsDataByType(this.typeUser);
        this.sortAndFormatStaffData();
    },

    methods: {
        ...popupPanelMapActions(['open']),
        async getThirdPermissions() {
            await this.$ajax.get(`/rest/third/client/init/${this.thirdid}`, {}, (response) => {
                this.permissions = response.dataoverview.permissions;
            });
        },
        async fetch() {
            this.staffsData = [];
            await this.$ajax.get(
                `/rest/sellsy-account-manager/third-connection/${this.thirdid}`,
                {},
                (response) => {
                    this.level = response.level;
                    this.corporationid = response.corporationid;
                    if (Object.keys(response.staffsData).length > 0) {
                        this.impersonateConsentCheck = response.impersonateConsentCheck;
                        Object.keys(response.staffsData).map((staffData) => {
                            this.staffsData.push(response.staffsData[staffData]);
                        });
                    }
                    this.loading = false;
                },
            );
        },
        filteredStaffsDataByType(type) {
            if (type === 'support') {
                this.filteredStaff.active = this.staffsData.filter((item) => {
                    return !['inactive', 'pending'].includes(item.authorizations.support);
                });
                this.filteredStaff.pending = this.staffsData.filter((item) => {
                    return item.authorizations.support === 'pending';
                });
            } else if (type === 'service') {
                this.filteredStaff.active = this.staffsData.filter((item) => {
                    return (
                        !['inactive', 'pending'].includes(item.authorizations.service) ||
                        !['inactive', 'pending'].includes(item.authorizations.support)
                    );
                });
                this.filteredStaff.pending = this.staffsData.filter((item) => {
                    return (
                        (item.authorizations.service === 'pending' ||
                            item.authorizations.support === 'pending') &&
                        !this.filteredStaff.active.includes(item)
                    );
                });
            } else if (
                this.isAdmin ||
                this.getUserAuthorizationLevel === 'all' ||
                (this.getUserAuthorizationLevel !== 'none' && this.level === 'trial')
            ) {
                this.filteredStaff.active = this.staffsData;
            }
        },
        sortAndFormatStaffData() {
            const formattedData = { ...this.filteredStaff };
            for (const key in this.filteredStaff) {
                formattedData[key] = this.filteredStaff[key]
                    .map((data) => {
                        const label = data.fullName;
                        const initials = label.charAt(0);
                        let expiryDate = null;

                        const hasPerpetualStatus = ['inactive', 'pending', 'advitam', 'active'];

                        if (!hasPerpetualStatus.includes(data.authorizations.support)) {
                            expiryDate = data.authorizations.support;
                        }

                        if (
                            !hasPerpetualStatus.includes(data.authorizations.service) &&
                            this.getDemandType === 'service'
                        ) {
                            if (
                                !expiryDate ||
                                moment(data.authorizations.service).isAfter(
                                    data.authorizations.support,
                                )
                            ) {
                                expiryDate = data.authorizations.service;
                            }
                        }

                        if (expiryDate !== null) {
                            expiryDate = this.$t.__('impersonate.days_left', {
                                days: moment(expiryDate).diff(moment(), 'days'),
                            });
                        }

                        if (Object.values(data.authorizations).includes('advitam')) {
                            expiryDate = 'AD VITAM';
                        }

                        return {
                            value: data.hash,
                            label: label,
                            labelCaption: `STAFFID ${data.staffid}`,
                            caption: expiryDate ?? '',
                            avatar: {
                                initials: initials,
                                colorType: this.avatarColor(label),
                                photo:
                                    data.staffType === 'sellsy'
                                        ? '/ressources/logged/img/icon/svg/sellsy_avatar.svg'
                                        : '',
                            },
                        };
                    })
                    .sort((a, b) => {
                        return a.label.localeCompare(b.label);
                    });
            }
            this.filteredStaff = { ...formattedData };
            this.selectDefaultConnection();
        },
        selectDefaultConnection() {
            if (this.filteredStaff.active?.length > 0) {
                this.connectionSelectModel = this.filteredStaff.active[0].value;
            }
        },
        fullname(staff) {
            let nameDisplay =
                staff.fullName && staff.fullName !== '' ? staff.fullName : staff.email;
            if (staff.ownerid === 0) {
                nameDisplay += ` [${this.$l10n.__('Créateur')}]`;
            }
            if (staff.status === 'blocked') {
                nameDisplay += ` [${this.$l10n.__('bloqué')}]`;
            }
            if (staff.status === 'deleted') {
                nameDisplay += ` [${this.$l10n.__('supprimé')}]`;
            }

            return nameDisplay;
        },
        connection(mode) {
            if (this.canConnect) {
                SellsyAdmin.initConnectionForm();
                SellsyAdmin.corpConnection(mode, this.connectionSelectModel);
            } else {
                Push.error(
                    this.$l10n.__(
                        "Vous n'avez pas les permissions nécessaires pour vous connecter.",
                    ),
                    false,
                );
            }
        },
        handleConsentDemandDialog() {
            this.open({
                key: 'connectionConsentDialog',
                props: {
                    demandType: this.getDemandType,
                    staff: this.activeStaff,
                    thirdId: parseInt(this.thirdid),
                    corpId: parseInt(this.corporationid),
                },
            });
        },
        handleCloseDialog() {
            this.displayConsentDialog = false;
        },
        handleSuccessDialog() {
            this.displayConsentDialog = false;
            this.fetch();
        },
    },
};
</script>

<style lang="scss" scoped>
.connection {
    .title {
        margin: 0 0 var(--spacing-1);
    }

    &__select {
        width: 100%;
        margin-bottom: var(--spacing-1);
    }

    &__empty {
        width: 100%;
        height: 48px;
        padding: var(--spacing-2);

        background-color: var(--colors-common-background-subtle);
        border: 1px solid var(--colors-common-border-default);
        border-radius: 4px;

        & > p {
            margin: 0;
        }
    }

    &__actions {
        display: flex;
        gap: var(--spacing-3);
    }

    .divider {
        display: flex;
        margin: var(--spacing-3) 0;
        border-bottom: 1px solid var(--colors-common-border-default);
    }
}
</style>
